import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Label } from "reactstrap";
import { useFormik } from "formik";
import moment from "moment";
import { createMeeting, editMeeting } from "../../api/meetings";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";
import momenttimezone from "moment-timezone";
import { Select, MenuItem, FormControl, Checkbox, ListItemText } from '@mui/material';
import * as Yup from "yup";

const CreateMeetings = ({ show, getMeetings, onHide, isLoading,getDateWiseMeetings, onDeleteEvent, selectedEvent, patients,isCreate, teamMembers = [], setIsLoading, selectedDate,currentDate }) => {
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  let user = useSelector((state) => state?.userReducer?.user);
  const userTimeZone = momenttimezone.tz.guess();
  const formik = useFormik({
    initialValues: {
      eventTitle: "",
      fromTime: "",
      toTime: "",
      teamMembers: [],
      patient: null,
      description: ""
    },
    validationSchema: Yup.object({
      eventTitle: Yup.string().required("Event title is required")
    }),
    onSubmit: async (values) => {
     // Convert selectedEvent start date to the user's timezone
     const eventDate = moment(selectedEvent?.start).format("YYYY-MM-DD");

     // Construct the eventData
     const eventData = {
       ...values,
       // Store the event date in UTC format (YYYY-MM-DD)
       date: moment.utc(selectedEvent?.start), // Ensure the date is UTC
       fromTime: values.fromTime
         ? moment
             .tz(eventDate + " " + values.fromTime, userTimeZone) // Combine the event date and user time
             .utc() // Convert to UTC
             .format() // Store in ISO 8601 format (UTC)
         : "",
       toTime: values.toTime
         ? moment
             .tz(eventDate + " " + values.toTime, userTimeZone) // Combine the event date and user time
             .utc() // Convert to UTC
             .format() // Store in ISO 8601 format (UTC)
         : "",
        patient: values?.patient?.value,
        teamMembers: values.teamMembers.map(member => ({
          userId: member.value,
          status: member?.status || "Pending"
        }))
      };

        let res;
        try {
          setIsLoading(true);
          if (selectedEvent?.eventId) {
            res = await editMeeting({ values: {...eventData, eventId : selectedEvent?.eventId}, dispatch, token });
          }else{
          res = await createMeeting({ values: {...eventData, organizationId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId")}, dispatch, token });
          }
          if (res?.status == "SUCCESS") {
              setIsLoading(false);
              success(res?.message);
              onHide();
              if(isCreate){
                getMeetings();
              }
              getDateWiseMeetings(currentDate);
              formik.resetForm();
          }else{
            setIsLoading(false);
            failed(res?.message);
          }
      } catch (error) {
          setIsLoading(false);
      }
    }
  });

  useEffect(() => {
    if (selectedEvent) {
      const selectedTeamMembers = selectedEvent?.teamMembers?.map(member => ({
        value: member?.userId?._id,
        label: member?.userId?.firstName + " " + member?.userId?.lastName,
        status: member?.status,
        email: member?.userId?.email
      }));
      const selectedPatient = patients.find(patient => patient.value === selectedEvent?.patient?._id?._id);
      const startDate = moment(selectedEvent?.start);
      const endDate = moment(selectedEvent?.end);

      formik.setValues({
        eventTitle: selectedEvent.title || "",
        date: startDate.format("YYYY-MM-DD"),
        fromTime: startDate.format("HH:mm"),
        toTime: endDate.format("HH:mm"),
        teamMembers: selectedTeamMembers || [],
        patient: selectedPatient || null,
        description: selectedEvent.description || ""
      });
    } else {
      formik.resetForm();
    }
  }, [selectedEvent]);

  const renderField = (label, name, type = "text",required = false) => (
    <>
      <label className="w-form-label">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <input
        name={name}
        type={type}
        // className="form-control"
        className={`form-control ${formik.touched[name] && formik.errors[name] ? 'is-invalid' : ''}`}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      {formik.touched[name] && formik.errors[name] && (
        <div className="invalid-feedback d-block">{formik.errors[name]}</div>
      )}
    </>
  );

  return (
    <Modal isOpen={show} toggle={onHide} size="lg">
              {isLoading ? (<Loader/>) : null}
      <ModalHeader className="assign_blk meet_blk p-3 m-0" toggle={onHide}>
        <span className="title-meeting">
          {selectedEvent?.eventId ? "Edit Meeting" : "Create New Meeting"} -{" "}
        </span>
        <span style={{ fontSize: "20px" }}>
          {moment(selectedEvent?.start || selectedDate).format(
            "dddd, MMMM DD, YYYY"
          )}
        </span>
      </ModalHeader>
      <form onSubmit={formik.handleSubmit}>
        <ModalBody style={{padding:"0 20px"}} className="create_meet">
          <Row><Col md={12} className="mb-3">{renderField("Add Title", "eventTitle", "text", true)}</Col></Row>
          <Row>
            <Col md={6} className="mb-3">
            {renderField("From Time", "fromTime", "time")}
            </Col>
            <Col md={6} className="mb-3">
            {renderField("To Time", "toTime", "time")}
            </Col>
          </Row>
          <Row>
          <Col md={6} className="mb-3">
            <FormControl fullWidth>
              <Label id="teamMembersLabel">Select Participants</Label>
              <Select
                labelId="teamMembersLabel"
                id="teamMembers"
                value={formik.values.teamMembers} // bind value to formik state
                onChange={(event) => {
                  const selectedValues = event.target.value; // this gives you an array of selected items
                  formik.setFieldValue("teamMembers", selectedValues); // update formik value when selection changes
                }}
                multiple
                renderValue={(selected) => selected.map(s => s.label).join(', ')} // display the selected labels
              >
                {teamMembers
                  .filter(mem => mem.value !== user?._id) // exclude current user
                  .map((member) => (
                    <MenuItem key={member.value} value={member}>
                      <Checkbox
                        checked={formik.values.teamMembers.some(
                          (item) => item.value === member.value
                        )}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent Select from firing
                          const currentSelected = formik.values.teamMembers;
                          const isSelected = currentSelected.some(
                            (item) => item.value === member.value
                          );

                          if (isSelected) {
                            // Deselect the item
                            formik.setFieldValue(
                              "teamMembers",
                              currentSelected.filter((item) => item.value !== member.value)
                            );
                          } else {
                            // Select the item
                            formik.setFieldValue("teamMembers", [...currentSelected, member]);
                          }
                        }}
                      />
                      <ListItemText primary={member.label} />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Col>
            <Col md={6} className="mb-3">
                <FormControl fullWidth>
                  <Label id="patientLabel">Select Patient</Label>
                  <Select
                    labelId="patientLabel"
                    id="patient"
                    value={formik.values.patient || null} // Ensure this is set to the full object, not just an ID
                    onChange={(event) => {
                      // Find the patient object from the options list by matching the ID
                      const selectedPatient = patients.find(patient => patient.value === event.target.value);
                      formik.setFieldValue("patient", selectedPatient); // Set the full patient object
                    }}
                    renderValue={(selected) => {
                      // Display the label of the selected patient
                      return selected ? selected.label : '';
                    }}
                  >
                    <MenuItem  value="">
                      <em>None</em>
                    </MenuItem>
                    {patients.map((patient) => (
                      <MenuItem key={patient.value} value={patient.value}>
                        {patient.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Col>
          </Row>
          <Row className="">
            <Col md={12}>
              <label className="w-form-label">Add Description</label>
              <textarea
                name="description"
                rows={4}
                className="form-control"
                value={formik.values.description}
                onChange={formik.handleChange}
                placeholder="Add a description"
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" type="submit">
            {selectedEvent?._id ? "Update" : "Save"}
          </Button>
          {selectedEvent?._id && (
            <Button
              color="danger"
              onClick={() => onDeleteEvent(selectedEvent._id)}
            >
              Delete
            </Button>
          )}
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default CreateMeetings;
